import { render } from "./bind_sub_entity.html?vue&type=template&id=fa0a59f6&external"
import script from "./bind_sub_entity.js?vue&type=script&lang=js&external"
export * from "./bind_sub_entity.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__